// extracted by mini-css-extract-plugin
module.exports = {"container":"modal_container__2qtBl"};